import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'


// 创建axios实例   (第一个实例)
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: '/gateway-api',
  // 超时
  timeout: 60000
})

export {service}




// WEBPACK FOOTER //
// ./src/utils/request.js